
import uploadForm from './form.vue';
import instructions from './instructions.vue';

export default {
  data: function data() {
    return {};
  },


  components: {
    uploadForm: uploadForm,
    instructions: instructions
  }
};